import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import Textarea from '~/src/components/form-components/textarea/textarea';
import { DropzoneUploaderDecorator } from '~/src/components/common-components/dropzone-uploader-decorator/dropzone-uploader-decorator';
import { useMatchMedia } from '~/src/hooks/use-match-media.hook';
import { MediaWidthEnum } from '~/src/models/enums/media-width.enum';
import { ATTR_NAMES_LEAD } from '~/src/models/constants/attr-names-lead.constants';
import {
    FILE_DATA,
    MAX_MESSAGE_TEXTAREA_LENGTH,
    TEXTAREA_HEIGHT,
} from '~/src/components/blocks/clients-request/additionally-block/additionally-block.constants';
import {
    onSendAddCommentAndFileAnalytics,
    onSendCommentTextAnalytics,
    onUploadFileAnalytics,
} from './additionally-block.analytics';
import plusIcon from '../../../../images/plus.png';
import { SectionContainerLeadPage, TitleLeadPage } from '~/src/styles/shared-css/common-lead.styles';
import type { WebAnalyticsEventCategoryEnum } from '~/src/models/enums/web-analytics.enum';
import * as Styled from './additionally-block.styles';

export interface AdditionallyBlockProps {
    title?: string;
    hasNeedReset?: boolean;
    onShow?: () => void;
    eventCategory: WebAnalyticsEventCategoryEnum;
}

export const AdditionallyBlock: FC<AdditionallyBlockProps> = ({
    title,
    hasNeedReset = false,
    onShow,
    eventCategory,
}) => {
    const [isMobile] = useMatchMedia(MediaWidthEnum.mobile, { withoutSSR: true });
    const [isShow, setIsShow] = useState(false);

    const handleClick = () => {
        setIsShow(true);
        onShow && onShow();
        onSendAddCommentAndFileAnalytics(eventCategory);
    };

    useEffect(() => {
        if (hasNeedReset) {
            setIsShow(false);
        }
    }, [hasNeedReset]);

    if (!isShow) {
        return (
            <Styled.TextButton tabIndex={0} role="button" onClick={handleClick}>
                <Styled.Plus src={plusIcon} alt={'Иконка-плюс'} />
                <Styled.TextWrap>
                    Добавить комментарий / <Styled.InlineBlockSpan>прикрепить файл</Styled.InlineBlockSpan>
                </Styled.TextWrap>
            </Styled.TextButton>
        );
    }

    const handleClickDropzoneUploader = () => {
        onUploadFileAnalytics(eventCategory);
    };

    const handleChangeTextComment = (event: ChangeEvent<HTMLTextAreaElement>) => {
        event.target.value?.length === 1 && onSendCommentTextAnalytics(eventCategory);
    };

    //TODO TitleLeadPage оставил на всякий случай, если где-то будет нужен title
    return (
        <SectionContainerLeadPage>
            {title && <TitleLeadPage>{title}</TitleLeadPage>}
            <Styled.AdditionallyBlockContainer>
                <Textarea
                    label={'Комментарий'}
                    name={ATTR_NAMES_LEAD.comment}
                    placeholder={'Добавьте комментарий'}
                    maxLength={MAX_MESSAGE_TEXTAREA_LENGTH}
                    height={TEXTAREA_HEIGHT}
                    onTextChange={handleChangeTextComment}
                />
                {FILE_DATA.map(
                    ({ id, type, labelFormat, typesFiles, title, maxSize, positionMobile, position, counts }) => (
                        <DropzoneUploaderDecorator
                            key={id}
                            typeField={type}
                            notificationPosition={isMobile ? positionMobile : position}
                            maxCountFiles={counts}
                            maxSizeInMB={maxSize}
                            correctTypesFiles={typesFiles}
                            titleText={title}
                            labelFormatFiles={labelFormat}
                            hideTitleAfterUpload
                            setFileUploadData={handleClickDropzoneUploader}
                        />
                    ),
                )}
            </Styled.AdditionallyBlockContainer>
        </SectionContainerLeadPage>
    );
};
